// extracted by mini-css-extract-plugin
export default {"ContractName":"_ContractName--h29nx","TooltipContent":"_TooltipContent--BOdD3","TooltipMessage":"_TooltipMessage--jLOjJ"};